import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Znamka} from '../model/znamka';
import {RozvrhovaAkcia} from '../model/RozvrhovaAkcia';
import { HttpClient } from '@angular/common/http';
import {AppService} from '../app.service';
import {TranslateService} from '@ngx-translate/core';
import {Predmety} from '../model/Predmety';

@Component({
    selector: 'app-rozvrhove-akcie',
    templateUrl: './rozvrhove-akcie.component.html',
    styleUrls: ['./rozvrhove-akcie.component.css'],
    standalone: false
})
export class RozvrhoveAkcieComponent implements OnInit {
  predmet: Znamka;
  akcie: RozvrhovaAkcia[];
  readOnly: boolean;

  constructor(
    public dialogRef: MatDialogRef<RozvrhoveAkcieComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {predmet: Znamka, akcie: RozvrhovaAkcia[]},
    private http: HttpClient,
    private appService: AppService,
    private translation: TranslateService
  ) {
    this.predmet = data.predmet;
    this.akcie = data.akcie;
    this.readOnly = this.predmet.prihlasovanieRozvrh === false;
  }

  ngOnInit(): void {
  }

  ulozit() {
    this.http.post<Predmety>(
      '/ais/rest/portal/student-predmety/rozvrhove-akcie',
      this.akcie,
    )
      .subscribe({
          next: (predmety) => {
              this.appService.setPredmety(predmety);
              this.appService.openSnackBar(
                  this.translation.instant('Zmeny boli uložené.')
              );
              this.dialogRef.close();
          },
          error: (error) => {
              this.appService.openErrorDialog(error.error.message);
          }
      });
  }

}
